import { render, staticRenderFns } from "./v-layout.vue?vue&type=template&id=d941a74e&scoped=true&"
import script from "./v-layout.vue?vue&type=script&lang=js&"
export * from "./v-layout.vue?vue&type=script&lang=js&"
import style0 from "./v-layout.vue?vue&type=style&index=0&id=d941a74e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d941a74e",
  null
  
)

export default component.exports